import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-white overflow-hidden" data-id="element-243">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-244"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/50 to-white" data-id="element-245"></div>

      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10" data-id="element-246">
        <div className="max-w-4xl" data-id="element-247">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium mb-6 border border-blue-100" data-id="element-248">
            <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" data-id="element-249"></span>
            AI Automation & Growth Consulting
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 tracking-tight leading-tight" data-id="element-250">
            Automate operations. <br className="hidden md:block" data-id="element-251" />
            Accelerate growth. <br className="hidden md:block" data-id="element-252" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500" data-id="element-253">
              Outpace the competition.
            </span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl leading-relaxed" data-id="element-254">
            We help mid-market companies deploy AI to streamline processes,
            optimize revenue engines, and drive measurable business outcomes.
            Stop experimenting and start scaling.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-255">
            <a href="#contact" className="px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all flex items-center justify-center gap-2 font-semibold shadow-lg shadow-blue-600/20 hover:shadow-xl hover:-translate-y-0.5" data-id="element-256">
              Book a Strategy Call <ArrowRightIcon size={18} data-id="element-257" />
            </a>
            <a href="#services" className="px-8 py-4 bg-white text-gray-800 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors flex items-center justify-center font-medium" data-id="element-258">
              See Our Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}